import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
	selector: 'app-sidenav-desktop',
	templateUrl: './sidenav-desktop.component.html',
	styleUrls: ['./sidenav-desktop.component.scss']
})
export class SidenavDesktopComponent {
	@Input() isExpanded$!: BehaviorSubject<boolean>;
	@Output() toggleSidenav = new EventEmitter();
	element!: HTMLElement;
}
